var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrowRight({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 14,
    viewBox: "0 0 15 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.40126 0.944124C8.12518 0.66804 7.67756 0.66804 7.40148 0.944124C7.12539 1.22021 7.12539 1.66783 7.40148 1.94391L11.692 6.23439H1.22209C0.831652 6.23439 0.515137 6.55091 0.515137 6.94135C0.515137 7.33179 0.831652 7.64831 1.22209 7.64831H11.6928L7.40131 11.9426C7.12532 12.2188 7.12547 12.6664 7.40164 12.9424C7.67782 13.2184 8.12544 13.2183 8.40143 12.9421L13.8988 7.44108C13.9013 7.43853 13.9038 7.43596 13.9064 7.43338C14.1103 7.22309 14.1577 6.91743 14.0487 6.66278C14.0178 6.59065 13.9743 6.52262 13.9184 6.46201C13.9724 6.52062 14.0168 6.58841 14.0487 6.66278",
    fill: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.40126 0.944124L13.8964 6.43921Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowRight);
export default __webpack_public_path__ + "static/media/arrow_right.765e8576b4bbdefb829672a765679c9a.svg";
export { ForwardRef as ReactComponent };